import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api, setUnauthorizedHandler } from '@/lib/api';

const AuthContext = createContext({ user: null, loading: true, login: () => {}, logout: () => {}, refresh: () => {} });

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem('cub_token');
    if (!token) { setUser(null); setLoading(false); return; }
    try {
      const me = await api.me();
      setUser(me);
    } catch (e) {
      localStorage.removeItem('cub_token');
      setUser(null);
    } finally { setLoading(false); }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('cub_token');
    setUser(null);
    if (window.location.pathname !== '/login') window.location.href = '/login';
  }, []);

  useEffect(() => {
    setUnauthorizedHandler(() => logout());
    loadMe();
  }, [loadMe, logout]);

  const login = async (email, password, remember_me = false) => {
    const data = await api.login(email, password, remember_me);
    localStorage.setItem('cub_token', data.access_token);
    setUser(data.user);
    return data.user;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refresh: loadMe }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export const isAdmin = (u) => u?.role === 'admin';
export const isSuperAdmin = (u) => u?.role === 'admin'; // alias UI: "Super Admin"
export const isBO = (u) => u?.role === 'partner'; // Back Office (ex "partner")
export const isAreaManager = (u) => u?.role === 'area_manager';
// isPartner: livello manager (B.O. o Area Manager) — condivide la maggior parte
// delle capacità aziendali. Usalo per check di visibilità/permessi generali.
export const isPartner = (u) => u?.role === 'partner' || u?.role === 'area_manager';
export const isAgent = (u) => u?.role === 'agent';
export const isInstaller = (u) => u?.role === 'installer';
export const isBoScintilla = (u) => u?.role === 'bo_scintilla';
// isScintillaStaff: staff Scintilla (admin + bo_scintilla). Vede/opera su tutto.
export const isScintillaStaff = (u) => u?.role === 'admin' || u?.role === 'bo_scintilla';

export const ROLE_LABELS = {
  admin: 'Super Admin',
  bo_scintilla: 'B.O. Scintilla',
  partner: 'B.O.',
  area_manager: 'Area Manager',
  agent: 'Agente',
  installer: 'Installatore',
};

export const roleLabel = (role) => ROLE_LABELS[role] || role || '—';
